import { Collapse } from '@/pages/aigc/components/Collapse';
import Portal from '@/pages/datalab/pages/Home/components/Portal';
import SvgIcon from '@home/components/SvgIcon';
import { useBoolean, useSize } from 'ahooks';
import React from 'react';
import './index.scss';
import BasicImage from '@home/components/BasicImage';
import DataIcon from '@/pages/aigc/assets/svg/prefixIcon.svg';
import GlobalIcon from '@/pages/aigc/assets/svg/global.png';
import EllipsisHover from '@gp/components/EllipsisHover';

export const IWikiReferenceCmp = (props: any) => {
  // eslint-disable-next-line react/prop-types
  const { value, messageId } = props;
  const [state, { toggle }] = useBoolean(false);
  const getReferenceUrl = (item: any) => {
    let url = '';
    if (item.type === 'databrain') {
      url = item.url?.startsWith('/') ? item.url : `/${item.url}`;
    }
    url = item.url;
    window.open(url, '_blank');
  };
  const parentDiv = document.querySelector('.dbh-agent-iwiki');
  const innerDiv = parentDiv?.querySelector('div');
  const size = useSize(innerDiv);
  return (
    <>
      <Portal attach={`#reference${messageId}`} className={''}>
        <div className="dba-reference-iwiki-container">
          <div onClick={toggle} className="dba-reference-iwiki-container-title">
            <span className="dba-reference-iwiki-container-num">
              引用{value?.length}篇资料作为参考
            </span>
            <SvgIcon type={state ? 'point-right' : 'point-down'} />
          </div>
        </div>
      </Portal>
      {state && (
        <Portal
          attach={`#reference${state ? `${messageId}-true` : messageId}`}
          className={''}
        >
          <Collapse isOpen={state}>
            <div className="dba-reference-iwiki-container-header">
              <span className="dba-reference-iwiki-container-header-title">
                来源
              </span>
              <SvgIcon type="clonse" onClick={toggle}></SvgIcon>
            </div>
            <div className="dba-reference-iwiki-container-list" style={{
              maxHeight: size?.height - 50,
            }}>
              {value?.map((item, index) => (
                <div
                  key={index}
                  className="dba-reference-iwiki-container-item"
                  onClick={() => getReferenceUrl(item)}
                >
                  <div>
                    <EllipsisHover text={`${index + 1}.  ${item?.name}`} />
                    <div className="dba-reference-iwiki-container-img">
                      <BasicImage
                        src={item?.type === 'databrain' ? DataIcon : GlobalIcon}
                        className={'dba-reference-iwiki-container-item-image'}
                        errorSrc={
                          item?.type === 'databrain' ? DataIcon : GlobalIcon
                        }
                      />
                      <span>
                        {item?.type === 'databrain' ? 'DataBrain' : item?.type}
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </Collapse>
        </Portal>
      )}
    </>
  );
};
